import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { FreeTextPresentation } from './FreeTextPresentation';

export function FreeTextPresentationDataHandler() {
  const {
    Utils: { fontOffset },
    useQuestion,
    useConfig,
    InteractiveCanvasComponents,
  } = usePresentationContext();

  const question = useQuestion();
  const { enableAnimations } = useConfig();

  return (
    <FreeTextPresentation
      question={question}
      shouldAnimate={enableAnimations}
      fontOffset={fontOffset}
      CanvasTitleArea={InteractiveCanvasComponents?.CanvasTitleArea}
      CanvasBodyArea={InteractiveCanvasComponents?.Body}
    />
  );
}
